import { useEffect } from 'react';

import { Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { useShowPostCheckoutCart } from 'store/Api';
import { LoadingOverlay } from 'ui';

import { useOnboardingReferrals } from '../../components/auth/hooks';

const PostCheckoutRedirectLayout = () => {
  const [searchParams] = useSearchParams();
  const {
    data: checkoutCartData,
    isInitialLoading,
    isError,
  } = useShowPostCheckoutCart({
    cartId: searchParams.get('cartId') ?? '',
    email: searchParams.get('email') ?? '',
  });

  const { setOnboardingCause } = useOnboardingReferrals();

  useEffect(() => {
    if (checkoutCartData?.cart?.cause?.uuid) {
      setOnboardingCause(checkoutCartData?.cart?.cause?.uuid);
    }
  }, [checkoutCartData?.cart?.cause?.uuid]);

  if (isInitialLoading && !checkoutCartData) {
    return <LoadingOverlay visible />;
  }

  if (isError) {
    return <Navigate to="/home" />;
  }

  return <Outlet />;
};

export { PostCheckoutRedirectLayout };
